export const Tab = {
  Deliverables: 'deliverables',
} as const;

export type Tab = (typeof Tab)[keyof typeof Tab];
